var EHDI = EHDI || Object.create(null);

var TreasureHunters = function(gameElement, gameSaveID, gameLevelComplete, gameEndFunction, htpShow, customTimeLimit) {
  EHDI.GAME = Object.create(null);
  EHDI.GAME.id = gameSaveID;
  EHDI.GAME.language = 'en';

  document.title = "Treasure Hunters";

  EHDI.GAME.constants = EHDI.GAME.constants || Object.create(null);
  Object.defineProperties(EHDI.GAME.constants, 
      {
        'boundHeight' : {value: 600},
        'boundWidth': {value : 1024},
        'gametimelimit' : {value : 300600},
        'customTimeLimit' : {value : customTimeLimit},
        'gameEndFunction' : {value : gameEndFunction},
        'gameLevelComplete' : {value : gameLevelComplete},
        'htpShow' : {value : htpShow},
        'gameName' : {value : 'Treasure Hunters'} 
      }
  );

  EHDI.canvas = document.createElement('canvas');
  EHDI.canvas.id = 'game-canvas';
  EHDI.canvas.style.cssText = "width: 100vw; height: 100vh; background-color: #081f46; background-image: -webkit-radial-gradient(circle farthest-side at 100% 100%, rgba(85, 224, 198, .63), rgba(85, 224, 198, 0)), -webkit-radial-gradient(circle farthest-side at 0% 0%, rgba(91, 134, 229, .67), rgba(91, 134, 229, 0)); background-image: radial-gradient(circle farthest-side at 100% 100%, rgba(85, 224, 198, .63), rgba(85, 224, 198, 0)), radial-gradient(circle farthest-side at 0% 0%, rgba(91, 134, 229, .67), rgba(91, 134, 229, 0));";
  EHDI.canvas.width = gameElement.style.width;
  EHDI.canvas.height = gameElement.style.height;
  gameElement.appendChild(EHDI.canvas);

  EHDI.GAME.sceneManager = EHDI.SceneManager(1024, 600);

  var sbResize = function () {

      resizeDelay = setTimeout(function() {
        var vendorGameElement = gameElement;
        var scaleX = vendorGameElement.offsetWidth / EHDI.GAME.sceneManager.defaultWidth;
        var scaleY = vendorGameElement.offsetHeight / EHDI.GAME.sceneManager.defaultHeight;
        var ratio = Math.min(scaleX, scaleY);
        var width;
        var height;
        var stage;
        var canvas;
  
        width = Math.ceil(EHDI.GAME.sceneManager.defaultWidth * ratio);
        height = Math.ceil(EHDI.GAME.sceneManager.defaultHeight * ratio);
        stage = EHDI.GAME.sceneManager.getStage();
  
        stage.scale.x = stage.scale.y = ratio;
        EHDI.GAME.sceneManager.getRenderer().resize(width, height);
  
        canvas = EHDI.GAME.sceneManager.getRenderer().view;
  
        canvas.style.paddingLeft = 0;
        canvas.style.paddingRight = 0;
        canvas.style.paddingTop = 0;
        canvas.style.paddingBottom = 0;
        canvas.style.display = 'block';
        canvas.style.position = 'absolute';
        canvas.style.top = 0;
        canvas.style.left = 0;
        canvas.style.right = 0;
        canvas.style.bottom = 0;
  
        if (width < vendorGameElement.offsetWidth) {
          var margin = (vendorGameElement.offsetWidth - width) / 2;
          canvas.style.left = margin + 'px';
          canvas.style.right = margin + 'px';
        }
  
        if (height < vendorGameElement.offsetHeight) {
          var margin = (vendorGameElement.offsetHeight - height) / 2;
          canvas.style.top = margin + 'px';
          canvas.style.bottom = margin + 'px';
        }
  
        window.scrollTo(0, 0);
      }, 350)
      
    };

  window.addEventListener("resize", sbResize);
  sbResize();

  EHDI.GAME.storageManager = EHDI.StorageManager();

  EHDI.GAME.updateManager = new EHDI.UpdateManager(EHDI.GAME.sceneManager.getRenderer(),
  EHDI.GAME.sceneManager.getStage());
  EHDI.GAME.soundManager = EHDI.SoundManager(true);

  var cache = EHDI.GAME.storageManager.getLocalInfo(EHDI.GAME.id) ||
  { isMuted: false, highScore : 0, isFirstTimePlay : true};

  EHDI.GAME.storageManager.setLocalInfo(EHDI.GAME.id, cache);
  EHDI.GAME.soundManager.setMute(cache.isMuted);

  var showLoadScene = function(){
  EHDI.LoadManager.queueAssets(AssetDirectory.preload);
  EHDI.LoadManager.start(
    function() {
      var promises = [];

      this.fontObserve = [];
      for(var i = 0; i < EHDI.Assets.fonts.length;i++){
          this.fontObserve[i] = new FontFaceObserver(EHDI.Assets.fonts[i]);
          promises.push(this.fontObserve[i].load(null, 8000));
      }

      Promise.all( promises ).then( function() {
            EHDI.loadScene();
      })
    });
  }

  showLoadScene();

  var destroy = function() {
    if(EHDI.GAME.gameScene) {
        EHDI.GAME.gameScene.dispose();
    }
    EHDI.GAME.updateManager.removeAllFrameListeners();
    EHDI.GAME.updateManager.deleteUpdateManager();
    window.removeEventListener("resize", sbResize);
    gameElement.removeChild(EHDI.canvas);
    EHDI.GAME.sceneManager.destroy();
    EHDI.GAME.soundManager.destroy();
}

var restart = function () {
    if(EHDI.GAME.gameScene) {
        EHDI.GAME.gameScene.restart();
    }
}

  return {
    destroy : destroy,
    restart : restart
  };
}

EHDI.onWindowLoad = function () {
  // EHDI.GAME = Object.create(null);
  // EHDI.GAME.id = GAMEID;
  // EHDI.GAME.language = 'en';
    
  //   EHDI.GAME.constants = EHDI.GAME.constants || Object.create(null);
  //   Object.defineProperties(EHDI.GAME.constants,
  //       {
  //       'boundHeight': {value: 600},
  //       'boundWidth':  {value: 1024},
  //       'gametimelimit': {value: 300600},
  //       }
  //   );

  // EHDI.sbGame = new SuperbookGame(EHDI.GAME.id, 'state', EHDI.init);

  // EHDI.sbGame.renderGameArea();
  // var vendorGameElement = EHDI.sbGame.getVendorGameElement();
  // EHDI.canvas = document.createElement('canvas');
  // EHDI.canvas.id = 'game-canvas';
  // EHDI.canvas.width = vendorGameElement.style.width;
  // EHDI.canvas.height = vendorGameElement.style.height;
  // vendorGameElement.appendChild(EHDI.canvas);
  // EHDI.sbGame.start();

  var vendorGameElement = document.createElement("div");
  vendorGameElement.style.width = window.innerWidth;
  vendorGameElement.style.height = window.innerHeight;
  vendorGameElement.style.backgroundColor = '#0c3f76';
  document.body.appendChild(vendorGameElement);

  var screenResize = function() {
    resizeClock = setTimeout(function() {
        vendorGameElement.style.width = window.innerWidth;
        vendorGameElement.style.height = window.innerHeight;
    }, 300);
  };

  window.addEventListener("resize", screenResize);
  screenResize();

  this.game = new TreasureHunters(vendorGameElement, '13062765', null, null, true);
};